// @flow
/* eslint-disable react/style-prop-object */
import * as React from 'react'
import BrandLogo from 'icon/BrandLogo'
import DismissIcon from 'icon/DismissIcon'
import HeartIcon from 'icon/HeartIcon'
import MagnifyingGlassIcon from 'icon/MagnifyingGlassIcon'
import type { User } from 'types'
import { Button } from 'ui/Form'
import Link from 'ui/Link'
import { homeUrl } from 'urls'
import { BasePageHeader, Layout, LayoutItem, type LinkManifest } from '../../common'
import SearchBar from './SearchBar'
import { type Filters } from '..'
import { WhitelabelContext } from 'main/framework'
import { AssetName } from 'main/util/asset'
import { spacing } from 'main/ui'

import './PageHeader.module.scss'

type Props = {
  user: User | null,
  linkManifests: LinkManifest[],
  filters: Filters,
  onUpdateFilters: (filters: $Shape<Filters>) => void,
  onClearFilters: () => void,
  onSearch: () => void,
}

type State = {
  showSearchBar: boolean,
}

export default class MarcomPageHeaderMobile extends React.Component<Props, State> {
  static contextType = WhitelabelContext
  constructor(props: Props) {
    super(props)

    this.state = {
      showSearchBar: false,
    }
  }

  render = () => {
    return (
      <BasePageHeader
        linkManifests={this.props.linkManifests}
        showNavMenuPrompt={!this.state.showSearchBar}
      >
        <div styleName="root">
          {this.state.showSearchBar ? this.renderSearchBarContent() : this.renderStandardContent()}
        </div>
      </BasePageHeader>
    )
  }

  renderSearchBarContent = () => {
    return (
      <React.Fragment>
        <Layout>
          <LayoutItem grow>{this.renderSearchBar()}</LayoutItem>
          <LayoutItem>{this.renderSearchBarPrompts()}</LayoutItem>
        </Layout>
      </React.Fragment>
    )
  }

  renderStandardContent = () => {
    return (
      <Layout>
        <LayoutItem>{this.renderBrand()}</LayoutItem>
        <LayoutItem>{this.renderStandardPrompts()}</LayoutItem>
      </Layout>
    )
  }

  renderBrand = () => {
    const whitelabelLogo = this.context.getAsset(AssetName.LOGO_SMALL)
    const whitelabelLinkUrl = this.context.getAsset(AssetName.LOGO_LINK_URL)

    const guts = whitelabelLogo ? (
      this.renderWhitelabeledLogo(whitelabelLogo)
    ) : (
      <BrandLogo layout="heightConstrained" />
    )
    return <div styleName="brand"> {this.linkOrAtag(homeUrl(), whitelabelLinkUrl, guts)}</div>
  }

  linkOrAtag = (linkUrl: any, whitelabelLinkUrl: any, guts: any) => {
    return whitelabelLinkUrl ? (
      <a href={whitelabelLinkUrl}>{guts}</a>
    ) : (
      <Link native href={linkUrl}>
        {guts}
      </Link>
    )
  }

  renderWhitelabeledLogo = (logo: any) => {
    return (
      <img
        src={`${logo}-/resize/x45/-/quality/smart/`}
        style={{ marginTop: `-${spacing.minorScale(3)}px` }}
      />
    )
  }

  renderSearchBar = () => {
    return (
      <div styleName="searchBar">
        <SearchBar
          location={this.props.filters.location}
          onUpdateFilters={this.props.onUpdateFilters}
          onSearch={this.props.onSearch}
        />
      </div>
    )
  }

  renderSearchBarPrompts = () => {
    return (
      <div styleName="prompts">
        <ButtonPrompt onClick={() => this.setState({ showSearchBar: false })}>
          <DismissIcon strokeColor="#28325b" layout="heightConstrained" />
        </ButtonPrompt>
      </div>
    )
  }

  renderStandardPrompts = () => {
    return (
      <div styleName="prompts removeHeaderRightPadding">
        {this.renderSearchBarPrompt()}
        {this.renderInterestedLinkPrompt()}
      </div>
    )
  }

  renderInterestedLinkPrompt = () => {
    return (
      <LinkPrompt href="/family/programs">
        <HeartIcon strokeColor="#28325b" layout="heightConstrained" />
      </LinkPrompt>
    )
  }

  renderSearchBarPrompt = () => {
    return (
      <ButtonPrompt onClick={() => this.setState({ showSearchBar: true })}>
        <MagnifyingGlassIcon strokeColor="#28325b" layout="heightConstrained" />
      </ButtonPrompt>
    )
  }
}

type ButtonPromptProps = {
  onClick: () => void,
  children: React.Node,
}

function ButtonPrompt(props: ButtonPromptProps) {
  return (
    <div>
      <Button appearance="naked" onClick={props.onClick}>
        <div styleName="promptContent">{props.children}</div>
      </Button>
    </div>
  )
}

type LinkPromptProps = {
  href: string,
  children: React.Node,
}

function LinkPrompt(props: LinkPromptProps) {
  return (
    <div>
      <Link href={props.href}>
        <div styleName="promptContent">{props.children}</div>
      </Link>
    </div>
  )
}
